import React from 'react';
import { MdCloudUpload, MdDeleteForever } from 'react-icons/md';
import { Field } from 'redux-form'

export const renderField = ({ type, meta: { touched, error, warning }, children, input, className, wrapperClassName, ...props }) => {
  return (
    <React.Fragment>
      <div className={`relative flex pb-6 ${wrapperClassName}`}>
        {
          type === 'select'
            ? <React.Fragment>
                <select {...input} className={`${className} ${touched && error ? 'border-red-600' : ''}`} {...props}>
                  { children}
                </select>
                {
                  !props.multiple &&
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 mb-6">
                      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                }
              </React.Fragment>
            : (
              type === 'textarea'
                ? <textarea {...input} className={`${className} ${touched && error ? 'border-red-600' : ''}`} {...props}></textarea>
                : <input type={type} {...input} className={`${className} ${touched && error ? 'border-red-600' : ''}`} {...props} />
            )
        }

        {
          touched &&
            ((error && <span className="absolute bottom-0 left-0 text-red-600 text-sm">{ error }</span>) ||
            (warning && <span className="absolute bottom-0 left-0 text-yellow-500 text-sm">{ warning }</span>))
        }
      </div>
    </React.Fragment>
  );
};

export const renderFileField = ({ type, meta: { touched, error, warning }, children, input, className, handleFile, ...props }) => {
  return (
    <React.Fragment>
      <div className="relative flex pb-6">
        <input {...input} className={`${className} ${touched && error ? 'border-red-600' : ''}`} {...props} />
        <div className="flex items-center justify-center">
          <label className="flex flex-col items-center tracking-wide w-auto bg-gray-600 hover:bg-gray-700 text-white font-bold py-4 px-4 rounded rounded-l-none cursor-pointer">
            <MdCloudUpload />
            <input accept="image/*" type="file" className="hidden"  onChange={handleFile(input.name)} />
          </label>
        </div>
      </div>

      {
        touched &&
          ((error && <span className="text-red-600 text-sm">{ error }</span>) ||
          (warning && <span className="text-yellow-500 text-sm">{ warning }</span>))
      }
    </React.Fragment>
  );
};

export const renderArray = ({ fields, template, meta: { error, submitFailed }}) => {
  return (
    <React.Fragment>
      <div className="w-full flex flex-row justify-between items-end mb-4">
        <span className="block uppercase tracking-wide text-gray-700 text-xs font-bold">{ template.label }</span>
        <button type="button" className={template.addButton.className} onClick={() => fields.push({})}>{ template.addButton.text }</button>
      </div>
      {
        fields.map((article, index) => (
          <div key={index} className="relative flex flex-col md:flex-row mb-1 w-full">
            {
              (template.fields || []).map(field => (
                <Field
                  key={field.id}
                  wrapperClassName={field.wrapperClassName}
                  className={field.className}
                  name={`${article}.${field.name}`}
                  type={field.type}
                  placeholder={field.placeholder}
                  component={renderField}
                  label={field.label}
                  validate={field.validate} />
              ))
            }
            <button type="button" className="bg-red-500 mb-6 text-white rounded px-4 py-4 md:py-0 flex justify-center items-center hover:bg-red-300" onClick={() => fields.remove(index)}>
              <MdDeleteForever />
              <span className="ml-2 font-bold text-white block md:hidden">Elimina</span>
            </button> 
          </div>
        ))
      }
    </React.Fragment>
  );
};
